<script lang="ts">
  import "../app.postcss";
  import { afterNavigate } from "$app/navigation";
  import { browser } from "$app/environment";
  import { onMount } from "svelte";
  import PrivacyConsentBanner from "../components/PrivacyConsentBanner.svelte";
  import PrivacyPreferencesDialog from "../components/PrivacyPreferencesDialog.svelte";
  import { initAnalyticsIfAllowed, trackPageView } from "$lib/analytics";
  import { initializePrivacyConsent, OPEN_PRIVACY_PREFERENCES_EVENT } from "$lib/privacy-consent";

  let privacyPreferencesOpen = false;

  const sendPageView = () => {
    if (!browser) {
      return;
    }
    initAnalyticsIfAllowed();
    trackPageView();
  };

  const markE2eReady = () => {
    if (browser) {
      document.documentElement.dataset.e2eReady = "true";
    }
  };

  let afterNavigateInitialized = false;

  if (browser) {
    afterNavigate(() => {
      markE2eReady();
      if (!afterNavigateInitialized) {
        afterNavigateInitialized = true;
        return;
      }
      sendPageView();
    });
  }

  onMount(() => {
    if (!browser) {
      return;
    }

    initializePrivacyConsent();
    markE2eReady();

    sendPageView();

    const openPrivacyPreferences = () => (privacyPreferencesOpen = true);
    window.addEventListener(OPEN_PRIVACY_PREFERENCES_EVENT, openPrivacyPreferences);
    return () => window.removeEventListener(OPEN_PRIVACY_PREFERENCES_EVENT, openPrivacyPreferences);
  });
</script>

<svelte:head>
  <title>Green Skills Coach from GetZero - Discover your green career pathway!</title>
</svelte:head>

<slot />
{#if !privacyPreferencesOpen}
  <PrivacyConsentBanner on:manage={() => (privacyPreferencesOpen = true)} />
{/if}
<PrivacyPreferencesDialog open={privacyPreferencesOpen} onClose={() => (privacyPreferencesOpen = false)} />
